import Vue from 'vue'
import Router from 'vue-router'
import ReportModel from '@/views/report/three.vue'
import AllReport from '@/views/report/four.vue'  //
import Model from '@/views/models.vue'
Vue.use(Router)
import '@/styles/index.scss' // global css

export default new Router({
  routes: [
    {
      path: '/all',   //行为测评
      name: 'ReportModel_pdf',
      component: AllReport
    },
    {
      path: '/allpdf',   //行为测评
      name: 'ReportModel_pdf',
      component: AllReport
    },
    {
      path: '/behavior',   //行为测评
      name: 'ReportModel_pdf',
      component: ReportModel
    },
    {
      path: '/behaviorpdf',
      name: 'ReportModel_pdf',
      component: ReportModel
    },

    {
      path: '/personality',   //人格测评
      name: 'ReportModel_pdf',
      component: ReportModel
    },
    {
      path: '/personalitypdf',
      name: 'ReportModel_pdf',
      component: ReportModel
    },

    {
      path: '/team',   //团队测评
      name: 'ReportModel_pdf',
      component: ReportModel
    },
    {
      path: '/teampdf',
      name: 'ReportModel_pdf',
      component: ReportModel
    },

    {
      path: '/home',   //心理测评
      name: 'ReportModel_home',
      component: ReportModel
    },
    {
      path: '/pdf',
      name: 'ReportModel_pdf',
      component: ReportModel
    },
    {
      path: '/models',
      name: 'ReportModel_pdf',
      component: Model
    },
    { path: '*', redirect: '/home', hidden: true },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js